/**
 * useTheme - Hook to get the current active theme
 * Use this hook in components to access theme colors that change based on theme mode
 */

import { useThemeContext } from './ThemeContext';
import { getTheme, type Theme } from './getTheme';

export const useTheme = (): Theme => {
  const { themeMode, brandPrimary } = useThemeContext();
  const theme = getTheme(themeMode);
  if (!brandPrimary) return theme;
  return { ...theme, ...brandPrimary };
};
